import React from 'react';
import { ICusProductListViewProps } from '../cus-product-list.data';

interface SeoSectionProps {
    props: ICusProductListViewProps;
}

export default function SeoSection({ props }: SeoSectionProps) {
    const categoryProducts = props.data.categoryProducts.result;
    const metaTitle = categoryProducts?.metaTitle;
    const seoDescription = categoryProducts?.seoDescription;

    if (!metaTitle && !seoDescription) {
        return null;
    }

    return (
        <section className='bs-product-list__seo'>
            {metaTitle && <h2 className='bs-product-list__seo__title'>{metaTitle}</h2>}
            {seoDescription && <div className='bs-product-list__seo__text' dangerouslySetInnerHTML={{ __html: seoDescription }} />}
        </section>
    );
}
